/**
 * Ponto de registro das etapas 2 (inspeções e manutenções) e 3 (documentos técnicos).
 */
import type { ForwardRefExoticComponent, RefAttributes } from 'react';
import type { ListStepProps, StepHandle } from '../ElectricalInstallationWizard.types';
import { DocumentsStep } from './DocumentsStep';
import { InspectionsStep } from './InspectionsStep';

export type ListStepComponent = ForwardRefExoticComponent<ListStepProps & RefAttributes<StepHandle>>;

/** Na ordem das etapas 2 e 3. */
export const ETAPAS_DE_REGISTRO: readonly [ListStepComponent, ListStepComponent] = [InspectionsStep, DocumentsStep];
